import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import ConfigurationService from '../../../services/ConfigurationService';
import { translate, isNullOrEmpty, formatData, getUserNameToName, testPrint, showMessageToastCustom } from '../../../utils/util';
import { validateInputsRequired, onValueChange } from '../../../utils/handleChangeHooks';
import { ENUMS } from '../../../utils/constants';
import { Breadcrumbs, Input, Button, ScannerCode, Label, Select } from '../../../components/UI/ComponentsUI';
import SelectNew from '../../../components/UI/SelectNew';

const PrintInsert = (props) => {
    const [print, setPrint] = useState({});
    const update = props.location?.state?.update;

    const isBluetoothRequired = !print?.address && !print?.port
    const isMacRequired = !print?.macAddress

    useEffect(() => {
        if (props.location?.state?.update && props.print) {
            setPrint({ ...props.print });
        }
        // eslint-disable-next-line
    }, [props.location?.state?.update, props.print]);

    const onChange = (event) => {
        onValueChange(event, print, setPrint);
    };

    const scanner = (value) => {
        if (!isNullOrEmpty(value)) {
            setPrint((prevState) => ({ ...prevState, macAddress: value }));
        }
    };

    const redirect = () => {
        props.history.replace('./list');
    }

    const onConfirm = () => {
        if (validateInputsRequired()) {
            if (update) {
                props.printPut(print, () => {
                    redirect();
                });
            } else {
                props.printPost(print, () => {
                    redirect();
                });
            }
        }
    };

    const titlePrint = { icon: "mdi mdi-clipboard-check-outline", label: translate('menu.configuration', 'configuration') };

    const subtitlesPrint = () => {
        let subtitlesItems = [];
        subtitlesItems = [...subtitlesItems, { icon: "mdi mdi-printer", label: translate('menu.printer', 'configuration') }];
        subtitlesItems = [...subtitlesItems, { label: update ? translate('menu.update', 'configuration') : translate('menu.insert', 'configuration') }];
        return subtitlesItems;
    }

    return (
        <div>
            <Breadcrumbs id="printInsert" title={titlePrint} subtitles={subtitlesPrint()} />
            <div className="container-fluid" style={{ marginTop: '25px', }}>
                <div className="container">
                    <div className="card">
                        <div className="card-content" style={{ padding: '10px', paddingBlockEnd: '1px' }}>
                            <div className="row" style={{ marginBottom: '0px' }}>
                                <fieldset className='fieldset'>
                                    <legend style={{ padding: '0 5px' }}> Info</legend>
                                    <div className="input-field no-padding col s12">
                                        <Input
                                            required
                                            label={translate('fields.name', 'printer')}
                                            id="name"
                                            name="name"
                                            type="text"
                                            onChange={onChange}
                                            value={print?.name || ''} />
                                    </div>
                                    <div className="row" style={{ marginBottom: '0px' }}>
                                        <div className="no-padding col s12">
                                            <SelectNew
                                                required
                                                id="connectionType"
                                                name="connectionType"
                                                placeHolder={translate('choose-one-option', 'general')}
                                                label={translate('fields.connectionType', 'printer')}
                                                data={[{ id: ENUMS.ePrinterConnectionType.Wifi.value, text: ENUMS.ePrinterConnectionType.Wifi.text },
                                                { id: ENUMS.ePrinterConnectionType.Bluetooth.value, text: ENUMS.ePrinterConnectionType.Bluetooth.text }]}
                                                change={onChange}
                                                value={print?.connectionType || ""}
                                            />
                                        </div>
                                    </div>
                                    {
                                        print?.connectionType && print?.connectionType.toString() === ENUMS.ePrinterConnectionType.Bluetooth.value.toString() &&
                                        <div className="row" style={{ marginBottom: '0px' }}>
                                            <div className="no-padding col s12">
                                                <Select
                                                    required
                                                    id="printerManufacture"
                                                    name="printerManufacture"
                                                    placeHolder={translate('choose-one-option', 'general')}
                                                    label="Fabricante"
                                                    data={[{ id: ENUMS.ePrinterManufacturerPortable.Honeywell.value, text: ENUMS.ePrinterManufacturerPortable.Honeywell.text },
                                                    { id: ENUMS.ePrinterManufacturerPortable.Zebra.value, text: ENUMS.ePrinterManufacturerPortable.Zebra.text }]}
                                                    change={onChange}
                                                    defaultValue={print?.printerManufacture || ''}
                                                />
                                            </div>
                                        </div>
                                    }
                                    <div className="input-field no-padding col s12">
                                        <Input type="checkbox" label={translate('fields.active', 'printer')} id="active" name="active" onChange={onChange} defaultChecked={print?.active} />
                                        <Input type="checkbox" label="Laser" id="laser" name="laser" onChange={onChange} defaultChecked={print?.laser} />
                                    </div>
                                </fieldset>
                                <fieldset className='fieldset'>
                                    <legend style={{ padding: '0 5px' }}> <i className="mdi mdi-wifi" /> Wifi</legend>
                                    <div className="input-field no-padding col s7">
                                        <Input
                                            required={isMacRequired}
                                            label={translate('fields.address', 'printer')}
                                            id="address"
                                            name="address"
                                            type="text"
                                            onChange={onChange}
                                            value={print?.address || ''} />
                                    </div>
                                    <div className="input-field no-padding col s4">
                                        <Input
                                            required={isMacRequired}
                                            label={translate('fields.port', 'printer')}
                                            id="port"
                                            name="port"
                                            type="number"
                                            onChange={onChange}
                                            value={print?.port || ''} />
                                    </div>
                                    <div className="input-field no-padding col s12">
                                        <Input
                                            type="checkbox"
                                            label={translate('fields.printserver', 'printer')}
                                            id="printserver" name="printserver"
                                            onChange={onChange}
                                            defaultChecked={print?.printserver} />
                                    </div>
                                </fieldset>
                                <fieldset className='fieldset'>
                                    <legend style={{ padding: '0 5px' }}> <i className="mdi mdi-bluetooth-settings" />Bluetooth</legend>
                                    <div className="input-field no-padding col s12">
                                        <ScannerCode onScanner={scanner} />
                                        <Input
                                            required={isBluetoothRequired}
                                            label={translate('fields.macAddress', 'printer')}
                                            id="macAddress"
                                            name="macAddress"
                                            type="text"
                                            onChange={onChange}
                                            value={print?.macAddress || ''}
                                        />
                                    </div>
                                </fieldset>
                            </div>
                            {
                                update &&
                                <>
                                    <div className="row" style={{ marginBottom: '0px' }}>
                                        <Label label={translate('fields.updateBy', 'printer')} id="updateBy" value={getUserNameToName(props.usersFromElog, print?.updateBy)} />
                                        <Label label={translate('fields.updateOn', 'printer')} id="updateOn" value={formatData(print?.updateOn)} />
                                    </div>
                                    <div className="row" style={{ paddingTop: '10px' }}>
                                        <Button full="true" onClick={() => {
                                            window.onMessageMobile = function (e) {
                                                if (!e.success) {
                                                    showMessageToastCustom(translate('warning', 'general'), e.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                                                }
                                            };
                                            testPrint(print?.macAddress, print?.printerManufacture)
                                        }} text="Teste Impressão" />
                                    </div>
                                </>
                            }
                            <div className="row" style={{ paddingTop: '10px' }}>
                                <Button onClick={() => props.history.goBack()} text={translate('cancel', 'general')} secundary="true" />
                                <Button onClick={() => onConfirm()} text={translate('confirm', 'general')} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
        print: state.configReducer.print,
        usersFromElog: state.usersElogReducer.usersElog

    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        printPost: (print, callback) => {
            dispatch(ConfigurationService.PostPrint(print, callback));
        },
        printPut: (print, callback) => {
            dispatch(ConfigurationService.PutPrint(print, callback));
        }
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(PrintInsert)));
